/* eslint-disable max-len,no-lonely-if */
/* global  window, localStorage */

export default function LoginController(
  $location,
  $window,
  $rootScope,
  $scope,
  $timeout,
  alerts,
  authorizationService,
  userService,
  loaderService,
  orgDataService,
  confirmDialog,
  ssDialogService,
  adalAuthenticationService,
  $routeParams,
) {
  const vm = this;

  // Set Default Values
  vm.appIsLoaded = false;
  vm.loginIsProcessing = false;
  vm.userName = '';
  vm.claims = [];
  vm.referenceCode = '';
  vm.invitedEmail = $routeParams.invitedEmail || '';
  userService.userName = '';
  vm.URL = document.URL.substring(0, document.URL.indexOf('#') ?? document.URL.length);
  vm.redirectBannerHidden = document.referrer === undefined || document.referrer === '' || vm.URL === document.referrer;

  // Attach Event Handlers
  vm.handleLoginFormSubmit = _handleLoginFormSubmit;
  vm.hideRedirectBanner = _hideRedirectBanner;
  _activate();

  /** ***********************************************
   * Private Functions
   */

  function _activate() {
    if (!checkCookieEnabled()) {
      alerts.error(
        'Cookies is not enabled on your browser. Please enable cookies and reload the login page to continue.',
      );
      return;
    }
    authorizationService.revokeToken();
    $rootScope.isAzureLog = false;
    loaderService.showViewLoader = false;
    vm.appIsLoaded = true;
    const isAzureLog = _getItem('is.azure.log');
    vm.referenceCode = _getItem('reference.code');
    if (vm.invitedEmail) {
      vm.userName = vm.invitedEmail;
      loaderService.showViewLoader = true;
      getUserInfo(true);
    } else {
      if (isAzureLog === 'true' && vm.referenceCode) {
        loaderService.showViewLoader = true;
        _saveItem('is.azure.log', '');
        if (adalAuthenticationService.userInfo && adalAuthenticationService.userInfo.isAuthenticated === true) {
          vm.userName = adalAuthenticationService.userInfo.profile.email;
          _azureAuthorizationSubmit();
        }
      }
    }
  }

  /** ***********************************************
   * Event Handlers
   */

  function _hideRedirectBanner() {
    vm.redirectBannerHidden = true;
  }

  function _handleLoginFormSubmit() {
    if (!checkCookieEnabled()) {
      alerts.error(
        'Cookies is not enabled on your browser. Please enable cookies and reload the login page to continue.',
      );
      return;
    }
    vm.loginIsProcessing = true;
    loaderService.showViewLoader = true;
    userService.userName = vm.userName;
    _saveItem('is.azure.log', '');
    getUserInfo(false);
  }

  function getUserInfo(inviteAccepted) {
    orgDataService
      .loginUser(vm.userName, inviteAccepted)
      .then(loginResponse => {
        /* OAuth server responded */
        vm.referenceCode = loginResponse.data.referenceCode;
        _saveItem('reference.code', vm.referenceCode);
        if (
          loginResponse.status === 200 &&
          loginResponse.data &&
          (loginResponse.data.error === null || loginResponse.data.error === '')
        ) {
          _loginUserNameSuccess(loginResponse);
        } else {
          _loginFailed('There was an error while logging in.');
        }
      })
      .catch(() => {
        _loginFailed('There was an error while logging in.');
      });
  }

  /**
   * OAuth server responded with something other than success
   * @param loginResponse
   */
  function _loginFailed(errorMessage) {
    authorizationService.revokeToken();
    vm.loginIsProcessing = false;
    userService.isLoggedOn = false;
    loaderService.showViewLoader = false;
    alerts.error(errorMessage);
    _saveItem('is.azure.log', '');
  }

  function _loginUserNameSuccess(loginResponse) {
    if (loginResponse.data.thirdParty === false) {
      if (loginResponse.data.authenticationSource === 'ActiveDirectory') {
        $location.path('/blockActiveDirectory');
      } else {
        $location.path('/password');
        // $location.path('/blockActiveDirectory');
      }
    } else {
      if (loginResponse.data.showResendInvitation === true) {
        alerts.error('Access to theSafe is restricted until the invitation step is complete.');
        loaderService.showViewLoader = false;
        vm.loginIsProcessing = false;
      } else {
        _adAzureLogin(loginResponse.data);
      }
    }
  }

  function _adAzureLogin(loginResponse) {
    _saveItem('azure.instance', loginResponse.authUrl);
    _saveItem('azure.tenant', loginResponse.tenant);
    _saveItem('azure.clientId', loginResponse.client);
    adalAuthenticationService.login();
  }

  function _azureAuthorizationSubmit() {
    vm.loginIsProcessing = true;
    loaderService.showViewLoader = true;
    _saveItem('is.azure.log', '');
    orgDataService
      .loginByAzureAD(vm.referenceCode, adalAuthenticationService.userInfo.profile)
      .then(loginResponse => {
        /* OAuth server responded */
        if (loginResponse.status === 200 && loginResponse.data) {
          _loginSuccessAzure(loginResponse);
        } else {
          _loginFailed('There was an error while logging in.');
        }
      })
      .catch(() => {
        _loginFailed('There was an error while logging in.');
      });
  }

  function _loginSuccessAzure(loginResponse) {
    const token = userService._getToken(loginResponse, vm.userName);
    authorizationService.setToken(token);

    const t = authorizationService.getToken();
    if (t && token.access_token !== t.access_token) {
      // Something not right SAFE-1098 PROD-Holly Azure user login issue in production.
      console.error('Token mismatch');
      $timeout(() => {
        _refreshUserInfo();
      }, 250);
    } else {
      _refreshUserInfo();
    }
  }

  function _refreshUserInfo() {
    return userService
      .refreshUser()
      .then(user => {
        console.log('User logged in', user);
        userService.isLoggedOn = true;
        $rootScope.isAzureLog = true;

        const lastLocation = _getItem('lastAccessLocation');
        if (lastLocation) {
          navigateLastLocation(lastLocation);
        } else {
          $location.path('/home');
        }

        $rootScope.$broadcast('loggedIn');
        $timeout(() => {
          angular.element('html')[0].scrollTop = 0;
        }, 0);

        orgDataService.logUserAccess();
      })
      .catch(err => {
        console.error(err);
        userService.isLoggedOn = false;
        if (err.data) {
          alerts.error(err.data.Message);
        }
      })
      .finally(() => {
        vm.loginIsProcessing = false;
        loaderService.showViewLoader = false;
      });
  }

  function navigateLastLocation(lastLocation) {
    _saveItem('lastAccessLocation', '');
    if (lastLocation === '/support/tickets') {
      if ($rootScope.isAzureLog === true) {
        $location.path('/home');
      } else {
        $location.path(lastLocation);
      }
    } else {
      $location.path(lastLocation);
    }
  }

  function _getItem(key) {
    return localStorage.getItem(key);
  }

  function _saveItem(key, obj) {
    localStorage.setItem(key, obj);
    return true;
  }

  function checkCookieEnabled() {
    return window.navigator.cookieEnabled && supportLocalStorage();
  }

  function supportLocalStorage() {
    try {
      return 'localStorage' in window && window.localStorage;
    } catch (e) {
      return false;
    }
  }
}

LoginController.$inject = [
  '$location',
  '$window',
  '$rootScope',
  '$scope',
  '$timeout',
  'alerts',
  'authorizationService',
  'userService',
  'loaderService',
  'orgDataService',
  'confirmDialog',
  'ssDialogService',
  'adalAuthenticationService',
  '$routeParams',
];
